import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { authStore } from '@/stores/auth'; // New import

// Import only the pages we need for the minimal setup
import DashboardPage from "../pages/Dashboard/DashboardPage.vue";
import CalcoloForfettarioPage from "../pages/Dashboard/CalcoloForfettarioPage.vue";
import ErrorPage from "../pages/ErrorPage.vue";

// Authentication Pages
import AuthPage from "@/pages/Authentication/AuthPage.vue"; // New AuthPage
import LockScreenPage from "@/pages/Authentication/LockScreenPage.vue";
import ForgotPasswordPage from "@/pages/Authentication/ForgotPasswordPage.vue";
import ResetPasswordPage from "@/pages/Authentication/ResetPasswordPage.vue";
import SimpleResetPasswordPage from "@/pages/SimpleResetPasswordPage.vue";


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
  },
  {
    path: "/calcolo/forfettario",
    name: "CalcoloForfettarioPage",
    component: CalcoloForfettarioPage,
  },
  // Consolidated Authentication Route
  {
    path: "/authentication/:tab?", // Optional tab parameter for deep linking
    name: "AuthPage",
    component: AuthPage,
    props: true, // Pass route params as props to the component
  },
  {
    path: "/authentication/lock-screen",
    name: "LockScreenPage",
    component: LockScreenPage,
  },
  {
    path: "/authentication/forgot-password",
    name: "ForgotPasswordPage",
    component: ForgotPasswordPage,
  },
  {
    path: "/authentication/forget-password",
    redirect: "/authentication/forgot-password",
  },
  {
    path: "/authentication/reset-password",
    name: "ResetPasswordPage",
    component: ResetPasswordPage,
  },
  {
    path: "/reset-password",
    name: "DirectResetPasswordPage",
    component: SimpleResetPasswordPage,
  },
  
  {
    // Keep the 404 error page route
    path: "/:pathMatch(.*)*",
    name: "ErrorPage",
    component: ErrorPage
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;